export const GET_ME_APPLICATIONS_AND_MESSAGES = `
  query {
    me {
      adverts {
        applicationDate
        invitedDate
        confirmedOpenHouseDate
        interestRequestSentDate
        interestedDate
        declinedDate
        updatedDate
        status
        availableActions
        selectedOpenHouseStart
        residenceAdvert {
          title
          id
          residence {
            address
            postalCode
            postalCity
            property {
              urlPath
            }
          }
        }
      }
      messages {
        advertId
        fromEmployeeId
        fromUserId
        created
        text
        id
      }
      unreadMessages {
        advertId
        fromEmployeeId
        fromUserId
        created
        text
        id
      }
    }
  }
`;

export const SEND_USER_TO_EMPLOYEE_MESSAGE = `
  mutation SendUserToEmployeeMessage(
    $advertId: ID!
    $text: String!
  ) {
    sendUserToEmployeeMessage(
      advertId: $advertId
      text: $text
    ) {
      fromEmployeeId
      id
      userId
      created
    }
  }
`;

export const PERFORM_ADVERT_ACTION = `
  mutation PerformAdvertAction(
    $residenceAdvertId: String!
    $action: UserAdvertApplicationAction!
    $reason: String
  ) {
    performAdvertAction(
      residenceAdvertId: $residenceAdvertId
      action: $action
      reason: $reason
    )
  }
`;

export const MARK_MESSAGE_AS_READ = `
  mutation MarkMessageAsRead($messageId: Int!) {
    markMessageAsRead(messageId: $messageId)
  }
`;

export interface SendMessageVariables {
  advertId: string;
  text: string;
}

export interface SendMessageResult {
  data: {
    sendUserToEmployeeMessage: {
      fromEmployeeId: string | null;
      id: number;
      userId: string;
      created: string;
    };
  };
}

export interface MarkMessageAsReadVariables {
  messageId: number;
}

export interface MarkMessageAsReadResult {
  data: {
    markMessageAsRead: boolean;
  };
}
